import message from '@/locale/es';

// Por favor, mantened el orden alfabético al añadir traducciones
message.advertising.maps.adMapContent = 'Contenidos';
message.advertising.slots.horizontalBanner = 'Banner horizontal';
message.advertising.slots.htmlAdPosition = 'Posición de HTML libre';
message.advertising.slots.mediumRectangle = 'Roba';
message.advertising.slots.megabannerAfterHeader = 'Megabanner Top Después de Cabecera';
message.advertising.slots.megabannerTop = 'Megabanner top';
message.advertising.slots.megabannerBottom = 'Megabanner bottom';
message.advertising.slots.sky = 'Sky';
message.block.dailymotion = 'dailymotion';
message.block.form.dailymotion = 'dailymotion';
message.block.form.dailymotionError = 'La URL introducida no es válida';
message.block.form.dailymotionPlaceholder = 'URL de DailyMotion';
message.block.tvchannel = 'Canal de TV';
message.confirmToPublishMessage = '¿Estás seguro de que quieres publicar?';
message.content.live.embed.dailymotionEmbed = 'dailymotion';
message.content.relation.relationMoreInfo = 'Notas relacionadas';
message.content.type.blogpost = 'Post';
message.content.type.html = 'Html';
message.content.type.interview = 'Entrevista';
message.content.type.longform = 'Gran reportaje';
message.content.type.newsletter = 'Newsletter';
message.content.type.opinion = 'Opinión - Análisis - Crónica';
message.content.type.opinionvignette = 'Viñeta';
message.editor.button.code = 'Código embed';
message.editor.button.html = 'Objeto HTML';
message.editor.button.dailymotion = 'Código dailymotion';
message.editor.button.tvchannel = 'Canal de TV';
message.editor.embed.dailymotion = 'Dailymotion';
message.editor.embed.tvchannel = 'Canal de TV';
message.editor.preview.additionalModes.cancelPartnerMode = 'Deshabilitar modo "Socio"';
message.editor.preview.additionalModes.disabledPartnerMode = 'Debes guardar el borrador para cambiar el modo de previsualización';
message.editor.preview.additionalModes.usePartnerMode = 'Habilitar modo "Socio"';
message.entity.type.blogpost = 'Post';
message.entity.type.focus = 'Suplementos';
message.entity.type.interview = 'Entrevista';
message.entity.type.longform = 'Gran reportaje';
message.entity.type.opinion = 'Opinión - Análisis - Crónica';
message.entity.type.opinionvignette = 'Viñeta';
message.entity.type.poll = 'Encuesta';
message.error.alreadyCloned = 'Este contenido ya ha sido clonado antes. El ID del clon es {value}';
message.form.fields.address = 'Dirección';
message.form.fields.adMapBoard = 'Mapa de portada';
message.form.fields.adMapContent = 'Mapa de contenido';
message.form.fields.adMapList = 'Mapa de listado';
message.form.fields.adMapMultimedia = 'Mapa de contenido multimedia';
message.form.fields.advanceOpenDate = 'Adelanto';
message.form.fields.alternativeAdPositionsComposition = 'Composición de módulos de reemplazo de publicidad para socios';
message.form.fields.appAndroidUrl = 'URL Store de Android';
message.form.fields.appBaseImageFile = 'IMAGEN APLICACIÓN MÓVIL (554X312)';
message.form.fields.appIosUrl = 'URL Store de Apple';
message.form.fields.appOneImageFile = 'IMAGEN APLICACIÓN MÓVIL (628X1268)';
message.form.fields.autopromoTitle = 'Título de Autopromo';
message.form.fields.autopromoBody = 'Cuerpo de Autopromo';
message.form.fields.autopromoButtonText = 'Texto del Botón Autopromo';
message.form.fields.autopromoButtonUrl = 'Url del Botón Autopromo';
message.form.fields.birthDate = 'Fecha de nacimiento';
message.form.fields.content = 'Contenido';
message.form.fields.contentFormat = 'Formato de contenido';
message.form.fields.contentImage = 'Imagen de contenido';
message.form.fields.contentKickerPretitle = 'Antetítulo del cintillo';
message.form.fields.contentKickerTitle = 'Título del cintillo';
message.form.fields.contentKickerLink = 'Enlace del cintillo';
message.form.fields.contentKickerOpeningType = 'Apertura del cintillo';
message.form.fields.contentKickerImage = 'Imagen del cintillo';
message.form.fields.contentUrl = 'URL';
message.form.fields.commentsType = 'Tipo de comentarios';
message.form.fields.counterMode = 'Modo de Contador';
message.form.fields.creationDate = 'Fecha de creación';
message.form.fields.cssUrls = 'URLs CSS';
message.form.fields.customHtmlContent = 'Html libre';
message.form.fields.customHtmlEndBody = 'Html libre final del body';
message.form.fields.customHtmlHead = 'Html libre final del head';
message.form.fields.customHtmlStartBody = 'Html libre inicio del body';
message.form.fields.destContent = 'Contenido';
message.form.fields.emailValidated = 'Email validado';
message.form.fields.enableContentImage = 'Activar imagen de contenido';
message.form.fields.endDate = 'Fecha de fin';
message.form.fields.epigraph = 'Epígrafe';
message.form.fields.featuredMenuNavigation = 'Navegación destacados';
message.form.fields.focusIds = 'Suplementos';
message.form.fields.followNewTab = 'Seguir en pestaña nueva';
message.form.fields.footerAutopromoButtonText = 'Texto del Botón Autopromo Footer';
message.form.fields.footerAutopromoButtonUrl = 'URL del Botón Autopromo Footer';
message.form.fields.footerAutopromoTitle = 'Título Autopromo Footer';
message.form.fields.frontpageFeatured = 'Página Principal Destacada';
message.form.fields.fullscreenOpening = 'Apertura 100%';
message.form.fields.fullWidth = 'Ancho Completo';
message.form.fields.gridId = 'Identificador en parrilla';
message.form.fields.hasFeaturedAuthors = 'Autores Destacados';
message.form.fields.headbandImageFile = 'Imagen Cintillo';
message.form.fields.headbandLink = 'Enlace del Cintillo';
message.form.fields.headbandTemplate = 'Plantilla del Cintillo';
message.form.fields.headbandTitle = 'Título Cintillo';
message.form.fields.headDecription = 'Decripción';
message.form.fields.homePhone = 'Teléfono fijo';
message.form.fields.hotTopicsNavigation = 'Navegación temas del día';
message.form.fields.html = 'HTML';
message.form.fields.icon = 'Icono';
message.form.fields.imageFileId = 'Imagen';
message.form.fields.imageId = 'Imagen de sección';
message.form.fields.imageKicker = 'Imagen de kicker';
message.form.fields.interviewed = 'Entrevistado';
message.form.fields.jsUrls = 'URLs JS';
message.form.fields.keywords = 'Keywords';
message.form.fields.kicker = 'Epígrafe';
message.form.fields.kickerImage = 'Imagen del epígrafe';
message.form.fields.kickerLink = 'Enlace para el epígrafe';
message.form.fields.kickerUrl = 'URL del epígrafe';
message.form.fields.linkText = 'Texto del enlace';
message.form.fields.listingImages = 'Imagen de listado';
message.form.fields.livePolitician = 'Minuto a minuto Político';
message.form.fields.longDescription = 'Descripción Extendida';
message.form.fields.mainMenuNavigation = 'Navegación principal';
message.form.fields.mediumRectangle = 'Robas';
message.form.fields.megabannerBottom = 'Megabanner Bottom';
message.form.fields.mediaInfo = 'Formato multimedia';
message.form.fields.mobilePhone = 'Teléfono móvil';
message.form.fields.moreInfoLink = 'Enlace Saber Más';
message.form.fields.moreInfoRelations = 'Contenidos';
message.form.fields.moreInfoText = 'Texto Saber Más';
message.form.fields.newsletterButtonText = 'Texto botón suscripción';
message.form.fields.newsletterItems = 'Elementos de newsletter';
message.form.fields.newsletterTitle = 'Titular';
message.form.fields.newsletterUrl = 'URL del formulario';
message.form.fields.newsSquareText = 'Texto Caja Inferior';
message.form.fields.newsSquareTitle = 'Título Caja Inferior';
message.form.fields.openInNewTab = 'Abrir en pestaña nueva';
message.form.fields.partnerImageId = 'Imagen de patrocinador';
message.form.fields.partnerImageUrl = 'Enlace para imagen de patrocinador';
message.form.fields.partnerReplacementContentId = 'Contenido de sustitución para socios';
message.form.fields.partnerReplacementRelationMultimedia = 'Multimedia de sustitución para socios';
message.form.fields.partnerReplacementTitle = 'Título de sustitución para socios';
message.form.fields.pollNumberVotes = 'Mostrar número de votos totales';
message.form.fields.pollNumberVotesPerResponse = 'Mostrar número de votos por respuesta';
message.form.fields.pollShowResults = 'Mostrar resultados';
message.form.fields.premium = 'Premium';
message.form.fields.premiumType = 'Premium';
message.form.fields.recirculationTitle = 'Título para tracking de recirculación (Compass)';
message.form.fields.relatedContentId = 'Contenido Relacionado';
message.form.fields.relatedContentsWithImage = 'Contenidos relacionados con imagen';
message.form.fields.relatedGalleries = 'Galerias Relacionadas';
message.form.fields.relatedImage = 'Imagen relacionada';
message.form.fields.relationMoreInfo = 'Relación Saber más';
message.form.fields.relationOg = 'Datos para Facebook';
message.form.fields.relationTwitter = 'Datos para Twitter';
message.form.fields.rightColumnRobas = 'Robas de columna derecha';
message.form.fields.seoDataOpen = 'Datos SEO';
message.form.fields.sex = 'sexo';
message.form.fields.shareAcronym = 'Acónimo';
message.form.fields.shareCode = 'Identificador en audiencias';
message.form.fields.shareColor = 'Color';
message.form.fields.showInGrid = 'Mostrar en parrilla';
message.form.fields.sidebarMenuNavigation = 'Navegación sidebar';
message.form.fields.skyLeft = 'Sky izquierdo';
message.form.fields.skyRight = 'Sky derecho';
message.form.fields.socialNetworks = 'Redes sociales';
message.form.fields.startDate = 'Fecha de inicio';
message.form.fields.subtitle = 'Subtítulo';
message.form.fields.subtitles = 'Subtítulos';
message.form.fields.subtitleUrl = 'URL del subtítulo';
message.form.fields.textblockBody = 'Cuerpo';
message.form.fields.textblockHeadline = 'Titular';
message.form.fields.textblockImageRelation = 'Imagen';
message.form.fields.textblockKicker = 'Epígrafe';
message.form.fields.tiktokUsername = 'Nombre de usuario de TikTok';
message.form.fields.blueskyUsername = 'Nombre de usuario de Bluesky';
message.form.fields.titleFontSize = 'Tamaño de fuente del títular';
message.form.fields.timeUnits = 'Contador: unidades de tiempo';
message.form.fields.timeUnitType = 'Contador: tipo de unidad de tiempo';
message.form.fields.youtubeUrl = 'Url de Youtube';
message.form.fields.whatsappChannel = 'ID de canal de WhatsApp';
message.form.scopes.adMapBoard = 'Mapa de portada';
message.form.scopes.adMapBoardMobile = 'Mapa de portada para móvil';
message.form.scopes.adMapContent = 'Mapa de contenido';
message.form.scopes.adMapContentMobile = 'Mapa de contenido para móvil';
message.form.scopes.adMapContentAmp = 'Mapa de contenido para AMP';
message.form.scopes.adMapContentMultimedia = 'Mapa de contenido multimedia';
message.form.scopes.adMapList = 'Mapa de listado';
message.form.scopes.adMapListMobile = 'Mapa de listado para móvil';
message.form.scopes.advertisingNetworkCode = 'ID adserver';
message.form.scopes.apps = 'Enlaces de Android Store y Apple Store';
message.form.scopes.articleCataloging = 'Catalogación';
message.form.scopes.articleLayoutModules = 'Bloques de HTML editables';
message.form.scopes.autopromo = 'Autopromo';
message.form.scopes.comments = 'Comentarios';
message.form.scopes.contentKicker = 'Cintillo';
message.form.scopes.counters = 'Contadores';
message.form.scopes.facebook = 'Facebook';
message.form.scopes.focus = 'Suplemento';
message.form.scopes.htmlAdPosition = 'Posición de HTML libre';
message.form.scopes.livePolitician = 'Minuto político';
message.form.scopes.localEditions = 'Ediciones locales';
message.form.scopes.newsletter = 'Newsletters';
message.form.scopes.paywall = 'Paywall';
message.form.scopes.premium = 'Premium';
message.form.scopes.rightColumn = 'Columna derecha';
message.form.scopes.shareData = 'Datos de audiencias';
message.form.scopes.textblock = 'Despiece';
message.form.scopes.theming = 'Personalización';
message.metadata.banned = 'Censurado';
message.metadata.communityModerated = 'Moderado por la comunidad';
message.metadata.featured = 'Seleccionado por la redacción';
message.metadata.gridChannel = 'Canal de TV';
message.metadata.pendingModeration = 'Pendiente de validación';
message.metadata.showAll = 'Ver todo';
message.navigation.advertising = { title: 'Configuración de publicidad' };
message.navigation.alert = { title: 'Urgente' };
message.navigation.cataloging.focuss = 'Suplementos';
message.navigation.contents.blogpost = 'Post';
message.navigation.contents.htmls = 'Htmls';
message.navigation.contents.interviews = 'Entrevistas';
message.navigation.contents.longforms = 'Grandes reportajes';
message.navigation.contents.opinions = 'Opinión - Análisis - Crónica';
message.navigation.contents.opinionvignettess = 'Viñetas';
message.navigation.contents.poll = 'Encuestas';
message.navigation.mainNavigation = { title: 'Menú principal' };
message.navigation.newsletters = { title: 'Newsletters' };
message.navigation.partnerReplacement = { title: 'Contenido de sustitución para socios' };
message.navigation.rightColumn = { title: 'Columna derecha' };
message.navigation.tools.gridChannels = 'Canales de TV';
message.navigation.tools.gridPrograms = 'Programas de TV';
message.permissions.actions.editTags = 'Asignar Tags';
message.permissions.filters.tools.hrefLang = 'Etiqueta HrefLang';
message.permissions.filters.tools.navigation = 'Navegaciones';
message.permissions.filters.tools.newsletter = 'Editor de newsletter';
message.permissions.filters.tools.partners_alternative_content = 'Contenido alternativo para socios';
message.permissions.filters.tools.reports = 'Reportes';
message.redirect['307'].label = 'Aplicar una redirección temporal';
message.redirect['308'].label = 'Aplicar una redirección permanente';
message.redirect['404'].label = 'Mostrar página de error';
message.redirect['410'].label = 'Indicar a los buscadores que esta página desapareció';
message.searcher.filters.advanceOpenDate = 'Fecha de apertura de adelanto';
message.searcher.filters.advanceState = 'Adelanto';
message.searcher.filters.authors = 'Autores';
message.searcher.filters.behaviour = 'Uso';
message.searcher.filters.channelId = 'Canal de TV';
message.searcher.filters.contentId = 'Contenido asociado a';
message.searcher.filters.eventDate = 'Fecha de evento';
message.searcher.filters.focuses = 'Suplementos';
message.searcher.filters.isLocalEdition = 'Edición local';
message.searcher.filters.lastPublicationDate = 'Fecha de Publicación';
message.searcher.filters.subscribersOnly = 'Sólo suscriptores';
message.searcher.filters.values.advanceState = { advance: 'Sí', notAdvance: 'No' };
message.searcher.filters.values.authors = 'Autores';
message.searcher.filters.values.behaviour = {};
message.searcher.filters.values.behaviour.landingPage = 'Página de caída';
message.searcher.filters.values.behaviour.taxonHome = 'Portada de categoría';
message.searcher.filters.values.behaviour.unlinked = 'Sin enlazar';
message.searcher.filters.values.eventDate = 'Fecha de evento';
message.searcher.filters.values.focuses = 'Suplementos';
message.searcher.filters.values.gridChannel = 'Canal de TV';
message.searcher.filters.values.isLocalEdition = { yes: 'Sí', no: 'No' };
message.searcher.filters.values.state.banned = 'Censurado';
message.searcher.filters.values.state.communityModerated = 'Moderado por la comunidad';
message.searcher.filters.values.state.featured = 'Seleccionado por la redacción';
message.searcher.filters.values.state.pendingModeration = 'Pendiente de validación';
message.searcher.filters.values.state.showAll = 'Ver todo';
message.searcher.filters.values.subscribersOnly = { yes: 'Sí', no: 'No' };
message.searcher.filters.values.type.adMapBoard = 'Mapa de portada';
message.searcher.filters.values.type.adMapContent = 'Mapa de contenido';
message.searcher.filters.values.type.adMapContentMultimedia = 'Mapa de contenido multimedia';
message.searcher.filters.values.type.adMapList = 'Mapa de listado';
message.searcher.filters.values.type.blogpost = 'Post';
message.searcher.filters.values.type.focus = 'Suplemento';
message.searcher.filters.values.type.html = 'Html';
message.searcher.filters.values.type.htmlAdPosition = 'Posición de HTML libre';
message.searcher.filters.values.type.horizontalBanner = 'Banner horizontal';
message.searcher.filters.values.type.interview = 'Entrevista';
message.searcher.filters.values.type.longform = 'Gran reportaje';
message.searcher.filters.values.type.mediumRectangle = 'Roba';
message.searcher.filters.values.type.megabannerAfterHeader = 'Megabanner Top Después de Cabecera';
message.searcher.filters.values.type.megabannerTop = 'Megabanner top';
message.searcher.filters.values.type.megabannerBottom = 'Megabanner bottom';
message.searcher.filters.values.type.opinion = 'Opinión - Análisis - Crónica';
message.searcher.filters.values.type.opinionvignette = 'Viñeta';
message.searcher.filters.values.type.sky = 'Sky';
message.searcher.sort.options.depthLevel = 'Profundidad en árbol de secciones';
message.searcher.sort.options.parentCategoryId = 'Id de la categoría padre';
message.searcher.sort.options.title = 'Título';
message.searcher.tab.gridChannel = 'Canales de TV';
message.searcher.tab.gridProgram = 'Programas de TV';
message.taxonomy.type.focus = 'Suplemento';
message.transcoding.type.high = 'Vídeo alto';
message.wizard.adMapBoard = 'Mapa de portada';
message.wizard.adMapContent = 'Mapa de contenido';
message.wizard.adMapContentMultimedia = 'Mapa de contenido multimedia';
message.wizard.adMapList = 'Mapa de listado';
message.wizard.adPosition = 'Posición de adserver';
message.wizard.adserverAdPosition = 'Posición de adserver';
message.wizard.blogpost = 'Post';
message.wizard.createAndContinueBtn = 'Crear otro';
message.wizard.createAndEditBtn = 'Editar {type}';
message.wizard.focus = 'Suplemento';
message.wizard.html = 'HTML';
message.wizard.htmlAdPosition = 'Posición de HTML libre';
message.wizard.interview = 'Entrevista';
message.wizard.longform = 'Gran reportaje';
message.wizard.navigation.focus = 'Suplemento';
message.wizard.navigation.chooseFocus = 'Selecciona un suplemento';
message.wizard.new.adMapBoard = 'Mapa de portada';
message.wizard.new.adMapContent = 'Mapa de contenido';
message.wizard.new.adMapContentMultimedia = 'Mapa de contenido multimedia';
message.wizard.new.adMapList = 'Mapa de listado';
message.wizard.new.blogpost = 'Nuevo Post';
message.wizard.new.html = 'Nuevo html';
message.wizard.new.htmlAdPosition = 'Nueva posición de HTML libre';
message.wizard.new.focus = 'Nuevo Suplemento';
message.wizard.new.interview = 'Nueva entrevista';
message.wizard.new.longform = 'Nuevo longform';
message.wizard.new.opinion = 'Nueva opinión';
message.wizard.new.opinionvignette = 'Nueva viñeta';
message.wizard.new.user = 'Nuevo usuario';
message.wizard.opinion = 'Opinión - Análisis - Crónica';
message.wizard.opinionvignette = 'Viñeta';
message.wizard.user = 'Usuario';

// Tipos de entidades moreInfo @see https://mgr.bitban.com/issues/99463
// @TODO tenemos que corregir en core que la respuesta de more-info devuelva algo como entity.type.author...
message.author = 'autor';
message.blog = 'blog';
message.focus = 'suplemento';
message.internaltag = 'tag interno';
message.microsite = 'microsite';
message.section = 'sección';
message.tag = 'tag';
// Por favor, mantened el orden alfabético al añadir traducciones
